/**
 * Analytics event models
 */

/**
 * Event categories
 */
export enum EventCategory {
  USER = 'user',
  CONTENT = 'content',
  SECURITY = 'security',
  SYSTEM = 'system',
  BUSINESS = 'business'
}

/**
 * Event severity levels
 */
export enum EventSeverity {
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  CRITICAL = 'critical'
}

/**
 * Client event types
 */
export enum ClientEventType {
  CLIENT_ERROR = 'client.error',
  CLIENT_WARNING = 'client.warning',
  CLIENT_INFO = 'client.info',
  CLIENT_PERFORMANCE = 'client.performance',
  API_ERROR = 'api.error'
}

/**
 * Actor information for events
 */
export interface EventActor {
  userId: string;
  userEmail?: string;
  userName?: string;
  orgId?: string;
}

/**
 * Resource information for events
 */
export interface EventResource {
  type: string;
  id: string;
  name?: string;
}

/**
 * Event context information
 */
export interface EventContext {
  requestId?: string;
  ip?: string;
  userAgent?: string;
  endpoint?: string;
  method?: string;
  duration?: number;
}

/**
 * Complete analytics event
 */
export interface AnalyticsEvent {
  eventId: string;
  eventType: string;
  category: EventCategory | string;
  severity: EventSeverity | string;
  timestamp: string;
  actor?: EventActor;
  resource?: EventResource;
  context?: EventContext;
  properties?: Record<string, any>;
  metadata?: Record<string, any>;
}

/**
 * Client event for logging from frontend
 */
export interface ClientEvent {
  eventType: ClientEventType | string;
  severity: EventSeverity | string;
  message: string;
  stackTrace?: string;
  orgId?: string;
  metadata?: Record<string, any>;
  url?: string;
  userAgent?: string;
}

/**
 * Client event response
 */
export interface ClientEventResponse {
  success: boolean;
  message: string;
  data?: {
    eventId: string;
    timestamp: string;
  };
}
